import { sliders } from '../modules/sliders';
import { new_mouse_hover, device_sniffer } from '../modules/page';

export default {
	init() {
		// JavaScript to be fired on all pages
		sliders();
		device_sniffer();
		new_mouse_hover();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js